<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="16">
        <!-- 人数统计 -->
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col :span="6">
            <div class="box box_down">
              <div class="left">
                <div class="num">-12</div>
                <div class="name">今日新增用户</div>
              </div>
              <i class="el-icon-bottom"></i>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="box box_up">
              <div class="left">
                <div class="num">1234</div>
                <div class="name">一周新增用户</div>
              </div>
              <i class="el-icon-top"></i>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="box box_up">
              <div class="left">
                <div class="num">12345</div>
                <div class="name">30天新增用户</div>
              </div>
              <i class="el-icon-top"></i>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="box box_up">
              <div class="left">
                <div class="num">123456</div>
                <div class="name">累积用户人数</div>
              </div>
              <i class="el-icon-top"></i>
            </div>
          </el-col>
        </el-row>

        <!-- 切换菜单 -->
        <el-card style="margin-bottom: 20px">
          <div class="btn-group" style="margin-bottom: 20px">
            <el-button-group>
              <el-button
                :type="currentTab === '0' ? 'primary' : ''"
                size="small"
                @click="siwtchTab('0')"
              >
                活跃用户
              </el-button>
              <el-button
                :type="currentTab === '1' ? 'primary' : ''"
                size="small"
                @click="siwtchTab('1')"
              >
                新增用户
              </el-button>
              <el-button
                :type="currentTab === '2' ? 'primary' : ''"
                size="small"
                @click="siwtchTab('2')"
              >
                累积用户
              </el-button>
            </el-button-group>
            <div class="block">
              <el-button-group>
                <el-button
                  :type="currentDateTab === '0' ? 'primary' : ''"
                  size="small"
                  @click="siwtchDateTab('0')"
                >
                  今天
                </el-button>
                <el-button
                  :type="currentDateTab === '1' ? 'primary' : ''"
                  size="small"
                  @click="siwtchDateTab('1')"
                >
                  一周
                </el-button>
                <el-button
                  :type="currentDateTab === '2' ? 'primary' : ''"
                  size="small"
                  style="border-right: 0; border-radius: 0"
                  @click="siwtchDateTab('2')"
                >
                  30天
                </el-button>
              </el-button-group>
              <el-date-picker
                v-model="daterange"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="border-radius: 0 3px 3px 0"
              />
            </div>
          </div>

          <!-- 折线图 -->
          <el-row id="line-box">
            <div v-show="currentTab === '0'" id="chartLine"></div>
            <div v-show="currentTab === '1'" id="chartLine2"></div>
            <div v-show="currentTab === '2'" id="chartLine3"></div>
          </el-row>
        </el-card>

        <!-- 地图 -->
        <el-row id="map-box" style="margin-bottom: 20px">
          <div v-show="currentTab === '0'" id="chartMap"></div>
          <div v-show="currentTab === '1'" id="chartMap2"></div>
          <div v-show="currentTab === '2'" id="chartMap3"></div>
        </el-row>
      </el-col>

      <el-col :span="8">
        <div class="box box_total">
          {{ date }}
        </div>

        <!-- 表格 -->
        <div class="table-block">
          <div class="table-title">最近登录用户信息</div>
          <el-row style="margin-bottom: 20px">
            <el-table :data="tableData" stripe style="width: 100%">
              <el-table-column
                prop="id"
                label="ID"
                width="100"
                align="center"
              />
              <el-table-column
                prop="name"
                label="姓名"
                min-width="100"
                align="center"
              />
              <el-table-column
                prop="date"
                label="日期"
                width="180"
                align="center"
              />
              <el-table-column
                prop="device"
                label="设备"
                width="80"
                align="center"
              />
            </el-table>
          </el-row>
        </div>

        <!-- 柱状图 -->
        <el-row id="bar-box" style="margin-bottom: 20px">
          <div v-show="currentTab === '0'" id="chartBar"></div>
          <div v-show="currentTab === '1'" id="chartBar2"></div>
          <div v-show="currentTab === '2'" id="chartBar3"></div>
        </el-row>
      </el-col>
    </el-row>

    <!-- 切换菜单 -->
    <el-card>
      <div class="btn-group" style="margin-bottom: 20px">
        <el-button-group>
          <el-button
            :type="currentTab2 === '0' ? 'primary' : ''"
            size="small"
            @click="siwtchTab2('0')"
          >
            用户登录终端统计
          </el-button>
          <el-button
            :type="currentTab2 === '1' ? 'primary' : ''"
            size="small"
            @click="siwtchTab2('1')"
          >
            APP各版本用户统计
          </el-button>
        </el-button-group>
      </div>

      <!-- 饼图 -->
      <el-row id="pie-box" style="margin-bottom: 20px">
        <el-row v-show="currentTab2 === '0'" :gutter="20">
          <el-col :span="12">
            <div id="chartPie"></div>
          </el-col>
          <el-col :span="12">
            <div id="chartPie2"></div>
          </el-col>
        </el-row>
        <el-row v-show="currentTab2 === '1'" :gutter="20">
          <el-col :span="12">
            <div id="chartPie3"></div>
          </el-col>
          <el-col :span="12">
            <div id="chartPie4"></div>
          </el-col>
        </el-row>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import "@/utils/map/js/china.js";

export default {
  data() {
    return {
      currentDateTab: '0',
      currentTab: '0',
      currentTab2: '0',
      value: '',
      daterange: '', // 自定义时间
      tableData: [
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        },
        {
          id: '1234567',
          name: '王小虎',
          date: '2020-02-02 22:22:22',
          device: 'Web'
        }
      ],
      cityList: [
        { name: '北京', value: 120 },
        { name: '天津', value: 50 },
        { name: '上海', value: 120 },
        { name: '重庆', value: 30 },
        { name: '河北', value: 10 },
        { name: '河南', value: 50 },
        { name: '云南', value: 10 },
        { name: '辽宁', value: 30 },
        { name: '黑龙江', value: 10 },
        { name: '湖南', value: 10 },
        { name: '安徽', value: 30 },
        { name: '山东', value: 30 },
        { name: '新疆', value: 0 },
        { name: '江苏', value: 70 },
        { name: '浙江', value: 10 },
        { name: '江西', value: 10 },
        { name: '湖北', value: 30 },
        { name: '广西', value: 10 },
        { name: '甘肃', value: 0 },
        { name: '山西', value: 10 },
        { name: '内蒙古', value: 30 },
        { name: '陕西', value: 10 },
        { name: '吉林', value: 30 },
        { name: '福建', value: 30 },
        { name: '贵州', value: 10 },
        { name: '广东', value: 120 },
        { name: '青海', value: 0 },
        { name: '西藏', value: 0 },
        { name: '四川', value: 50 },
        { name: '宁夏', value: 10 },
        { name: '海南', value: 0 },
        { name: '台湾', value: 10 },
        { name: '香港', value: 10 },
        { name: '澳门', value: 10 }
      ],
      dataSource: [{ name: 'China', value: 50 }],
      date: '',
      chartLine: null,
      chartLineOption: {},
      chartLine2: null,
      chartLineOption2: {},
      chartLine3: null,
      chartLineOption3: {},
      chartMap: null,
      chartMapOption: {},
      chartMap2: null,
      chartMapOption2: {},
      chartMap3: null,
      chartMapOption3: {},
      chartBar: null,
      chartBarOption: {},
      chartBar2: null,
      chartBarOption2: {},
      chartBar3: null,
      chartBarOption3: {},
      chartPie: null,
      chartPieOption: {},
      chartPie2: null,
      chartPieOption2: {},
      chartPie3: null,
      chartPieOption3: {},
      chartPie4: null,
      chartPieOption4: {}
    }
  },
  computed: {
    getSidebarStatus() {
      return this.$store.state.app.sidebar.opened
    }
  },
  watch: {
    getSidebarStatus() {
      setTimeout(() => {
        switch (this.currentTab) {
          case '0':
            this.chartLine.resize()
            this.chartMap.resize()
            this.chartBar.resize()
            break
          case '1':
            this.chartLine2.resize()
            this.chartMap2.resize()
            this.chartBar2.resize()
            break
          case '2':
            this.chartLine3.resize()
            this.chartMap3.resize()
            this.chartBar3.resize()
            break
        }

        switch (this.currentTab2) {
          case '0':
            this.chartPie.resize()
            this.chartPie2.resize()
            break
          case '1':
            this.chartPie3.resize()
            this.chartPie4.resize()
            break
        }
      }, 300)
    }
  },
  mounted() {
    this.drawLine('0')
    this.drawMap('0')
    this.drawBar('0')
    this.drawPie('0')
    // this.setTime()
  },
  methods: {
    setTime() {
      const myDate = new Date()
      this.date = myDate.toLocaleString('chinese', { hour12: false })
      setInterval(() => {
        this.setTime()
      }, 1000)
    },
    /**
     * 切换日期
     */
    siwtchDateTab(index) {
      if (this.currentDateTab === index) return
      this.currentDateTab = index

      if (index === '0') {
        if (this.currentTab === '0') {
          this.chartLineOption.xAxis.data = [
            '0:00',
            '1:00',
            '2:00',
            '3:00',
            '4:00',
            '5:00',
            '6:00',
            '7:00',
            '8:00',
            '9:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
            '24:00'
          ]
          this.chartLineOption.series[0].data = [
            82,
            92,
            91,
            94,
            94,
            120,
            120,
            130,
            82,
            55,
            50,
            82,
            62,
            120,
            50,
            43,
            130,
            82,
            92,
            130,
            91,
            94,
            120,
            130,
            130
          ]
          this.chartLine.setOption(this.chartLineOption)
        }
      }

      if (index === '1') {
        switch (this.currentTab) {
          case '0':
            this.chartLineOption.xAxis.data = [
              '周一',
              '周二',
              '周三',
              '周四',
              '周五',
              '周六',
              '周日'
            ]
            this.chartLineOption.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210
            ]
            this.chartLine.setOption(this.chartLineOption)
            break
          case '1':
            this.chartLineOption2.xAxis.data = [
              '周一',
              '周二',
              '周三',
              '周四',
              '周五',
              '周六',
              '周日'
            ]
            this.chartLineOption2.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210
            ]
            this.chartLine2.setOption(this.chartLineOption2)
            break
          case '2':
            this.chartLineOption3.xAxis.data = [
              '周一',
              '周二',
              '周三',
              '周四',
              '周五',
              '周六',
              '周日'
            ]
            this.chartLineOption3.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210
            ]
            this.chartLine3.setOption(this.chartLineOption3)
            break
        }
      }

      if (index === '2') {
        switch (this.currentTab) {
          case '0':
            this.chartLineOption.xAxis.data = [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '21',
              '22',
              '23',
              '24',
              '25',
              '26',
              '27',
              '28',
              '29',
              '30'
            ]
            this.chartLineOption.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230
            ]
            this.chartLine.setOption(this.chartLineOption)
            break
          case '1':
            this.chartLineOption2.xAxis.data = [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '21',
              '22',
              '23',
              '24',
              '25',
              '26',
              '27',
              '28',
              '29',
              '30'
            ]
            this.chartLineOption2.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230
            ]
            this.chartLine2.setOption(this.chartLineOption2)
            break
          case '2':
            this.chartLineOption3.xAxis.data = [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '21',
              '22',
              '23',
              '24',
              '25',
              '26',
              '27',
              '28',
              '29',
              '30'
            ]
            this.chartLineOption3.series[0].data = [
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230,
              134,
              90,
              230,
              210,
              120,
              132,
              101,
              134,
              90,
              230
            ]
            this.chartLine3.setOption(this.chartLineOption3)
            break
        }
      }
    },
    /**
     * 切换菜单1
     */
    siwtchTab(index) {
      this.currentTab = index
      this.currentDateTab = '0'
      setTimeout(() => {
        this.drawLine(index)
        this.drawMap(index)
        this.drawBar(index)
      }, 300)
    },
    /**
     * 切换菜单2
     */
    siwtchTab2(index) {
      this.currentTab2 = index
      setTimeout(() => {
        this.drawPie(index)
      }, 300)
    },
    /**
     * 生成折线图
     */
    drawLine(index) {
      switch (index) {
        case '0':
          this.chartLine = this.$echarts.init(
            document.getElementById('chartLine')
          )
          this.chartLineOption = {
            title: {
              text: '活跃用户折线图',
              x: 'center',
              top: '5%'
            },
            tooltip: {
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            grid: {
              top: '15%',
              left: '2%',
              right: '2%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine.setOption(this.chartLineOption)
          break
        case '1':
          this.chartLine2 = this.$echarts.init(
            document.getElementById('chartLine2')
          )
          this.chartLineOption2 = {
            title: {
              text: '新增用户折线图',
              x: 'center',
              top: '5%'
            },
            grid: {
              top: '15%',
              left: '2%',
              right: '2%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine2.setOption(this.chartLineOption2)
          break
        case '2':
          this.chartLine3 = this.$echarts.init(
            document.getElementById('chartLine3')
          )
          this.chartLineOption3 = {
            title: {
              text: '累积用户折线图',
              x: 'center',
              top: '5%'
            },
            grid: {
              top: '15%',
              left: '2%',
              right: '2%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine3.setOption(this.chartLineOption3)
          break
      }
    },
    /**
     * 生成地图
     */
    drawMap(index) {
      switch (index) {
        case '0':
          this.chartMap = this.$echarts.init(
            document.getElementById('chartMap')
          )
          this.chartMapOption = {
            title: {
              text: '活跃用户分布图',
              x: 'center',
              top: '5%'
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            tooltip: {
              trigger: 'item'
            },
            visualMap: {
              show: false,
              x: 'left',
              y: 'bottom',
              splitList: [
                { start: 100, end: 10000 },
                { start: 60, end: 100 },
                { start: 40, end: 60 },
                { start: 20, end: 40 },
                { start: 1, end: 20 },
                { start: 0, end: 0 }
              ],
              color: [
                '#E6A23C',
                '#EAB35F',
                '#EFC382',
                '#F3D4A4',
                '#F8E4C7',
                '#FCF5EA'
              ]
            },
            series: [
              {
                name: '观看人数',
                type: 'map',
                mapType: 'china',
                roam: false, // 是否开启鼠标缩放和平移漫游。
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                data: this.cityList
              }
            ]
          }
          this.chartMap.setOption(this.chartMapOption)
          break
        case '1':
          this.chartMap2 = this.$echarts.init(
            document.getElementById('chartMap2')
          )
          this.chartMapOption2 = {
            title: {
              text: '新增用户分布图',
              x: 'center',
              top: '5%'
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            tooltip: {
              trigger: 'item'
            },
            visualMap: {
              show: false,
              x: 'left',
              y: 'bottom',
              splitList: [
                { start: 80, end: 1000 },
                { start: 20, end: 80 },
                { start: 40, end: 60 },
                { start: 20, end: 40 },
                { start: 20, end: 40 },
                { start: 0, end: 20 }
              ],
              color: [
                '#E6A23C',
                '#EAB35F',
                '#EFC382',
                '#F3D4A4',
                '#F8E4C7',
                '#FCF5EA'
              ]
            },
            series: [
              {
                name: '观看人数',
                type: 'map',
                mapType: 'china',
                roam: false, // 是否开启鼠标缩放和平移漫游。
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                data: this.cityList
              }
            ]
          }
          this.chartMap2.setOption(this.chartMapOption2)
          break
        case '2':
          this.chartMap3 = this.$echarts.init(
            document.getElementById('chartMap3')
          )
          this.chartMapOption3 = {
            title: {
              text: '累积用户分布图',
              x: 'center',
              top: '5%'
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            tooltip: {
              trigger: 'item'
            },
            visualMap: {
              show: false,
              x: 'left',
              y: 'bottom',
              splitList: [
                { start: 80, end: 1000 },
                { start: 20, end: 80 },
                { start: 40, end: 60 },
                { start: 20, end: 40 },
                { start: 20, end: 40 },
                { start: 0, end: 20 }
              ],
              color: [
                '#E6A23C',
                '#EAB35F',
                '#EFC382',
                '#F3D4A4',
                '#F8E4C7',
                '#FCF5EA'
              ]
            },
            series: [
              {
                name: '观看人数',
                type: 'map',
                mapType: 'china',
                roam: false, // 是否开启鼠标缩放和平移漫游。
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                data: this.cityList
              }
            ]
          }
          this.chartMap3.setOption(this.chartMapOption3)
          break
      }
    },
    /**
     * 生成柱状图
     */
    drawBar(index) {
      switch (index) {
        case '0':
          this.chartBar = this.$echarts.init(
            document.getElementById('chartBar')
          )
          this.chartBarOption = {
            title: {
              text: '活跃用户前十的省份',
              x: 'center',
              top: '5%'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: [
                '北京',
                '陕西',
                '辽宁',
                '福建',
                '四川',
                '重庆',
                '上海',
                '江苏',
                '浙江',
                '广东'
              ]
            },
            series: [
              {
                type: 'bar',
                data: [3, 4, 6, 7, 8, 11, 16, 20, 21, 25],
                itemStyle: {
                  normal: {
                    color: '#F56C6C'
                  }
                }
              }
            ]
          }
          this.chartBar.setOption(this.chartBarOption)
          break
        case '1':
          this.chartBar2 = this.$echarts.init(
            document.getElementById('chartBar2')
          )
          this.chartBarOption2 = {
            title: {
              text: '新增用户前十省份',
              x: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: [
                '北京',
                '陕西',
                '辽宁',
                '福建',
                '四川',
                '重庆',
                '上海',
                '江苏',
                '浙江',
                '广东'
              ]
            },
            series: [
              {
                type: 'bar',
                data: [3, 4, 6, 7, 8, 11, 16, 20, 21, 25],
                itemStyle: {
                  normal: {
                    color: '#F56C6C'
                  }
                }
              }
            ]
          }
          this.chartBar2.setOption(this.chartBarOption2)
          break
        case '2':
          this.chartBar3 = this.$echarts.init(
            document.getElementById('chartBar3')
          )
          this.chartBarOption3 = {
            title: {
              text: '累积用户前十省份',
              x: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              top: '15%',
              left: '5%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: [
                '北京',
                '陕西',
                '辽宁',
                '福建',
                '四川',
                '重庆',
                '上海',
                '江苏',
                '浙江',
                '广东'
              ]
            },
            series: [
              {
                type: 'bar',
                data: [3, 4, 6, 7, 8, 11, 16, 20, 21, 25],
                itemStyle: {
                  normal: {
                    color: '#F56C6C'
                  }
                }
              }
            ]
          }
          this.chartBar3.setOption(this.chartBarOption3)
          break
      }
    },
    /**
     * 生成饼图
     */
    drawPie(index) {
      switch (index) {
        case '0':
          this.chartPie = this.$echarts.init(
            document.getElementById('chartPie')
          )
          this.chartPieOption = {
            title: {
              text: '用户登录终端统计',
              left: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: '20',
              top: '20',
              data: ['Web端', 'PC端', 'APP端']
            },
            series: [
              {
                name: '访问来源',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 135, name: 'Web端' },
                  { value: 600, name: 'PC端' },
                  { value: 1548, name: 'APP端' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          this.chartPie.setOption(this.chartPieOption)

          this.chartPie2 = this.$echarts.init(
            document.getElementById('chartPie2')
          )
          this.chartPieOption2 = {
            title: {
              text: 'APP端用户统计',
              left: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: '20',
              top: '20',
              data: ['Android', 'iOS']
            },
            series: [
              {
                name: '访问来源',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 135, name: 'iOS' },
                  { value: 200, name: 'Android' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          this.chartPie2.setOption(this.chartPieOption2)
          break
        case '1':
          // Android
          this.chartPie3 = this.$echarts.init(
            document.getElementById('chartPie3')
          )
          this.chartPieOption3 = {
            title: {
              text: 'Android',
              left: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: '20',
              top: '20',
              data: ['0.3.3', '0.3.2', '0.3.1或更低版本']
            },
            series: [
              {
                name: '使用版本',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 310, name: '0.3.3' },
                  { value: 335, name: '0.3.2' },
                  { value: 234, name: '0.3.1或更低版本' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          this.chartPie3.setOption(this.chartPieOption3)

          // iOS
          this.chartPie4 = this.$echarts.init(
            document.getElementById('chartPie4')
          )
          this.chartPieOption4 = {
            title: {
              text: 'iOS',
              left: 'center',
              top: '20'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: '20',
              top: '20',
              data: ['0.3.3', '0.3.2', '0.3.1或更低版本']
            },
            series: [
              {
                name: '使用版本',
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data: [
                  { value: 90, name: '0.3.3' },
                  { value: 435, name: '0.3.2' },
                  { value: 334, name: '0.3.1或更低版本' }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          this.chartPie4.setOption(this.chartPieOption4)
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  color: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .left {
    .num {
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      margin-bottom: 10px;
    }
    .name {
      height: 30px;
      line-height: 30px;
    }
  }

  .el-icon-top,
  .el-icon-bottom {
    font-size: 60px;
  }
}
.box_total {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #409eff;
  font-size: 40px;
  height: 122px;
}
.box_up {
  background-color: #67c23a;
}
.box_down {
  background-color: #f56c6c;
}

.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.block {
  display: flex;
  align-items: center;
}

.table-block {
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 20px 0;

  .table-title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    height: 74px;
    font-size: 18px;
    border-bottom: 1px solid #ebeef5;
  }
}

#chartMap,
#chartMap2,
#chartMap3,
#chartBar,
#chartBar2,
#chartBar3 {
  width: 100%;
  height: 500px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

#chartLine,
#chartLine2,
#chartLine3 {
  width: 100%;
  height: 330px;
}

#chartMap,
#chartMap2,
#chartMap3 {
  height: 700px;
}

#chartPie,
#chartPie2,
#chartPie3,
#chartPie4 {
  width: 100%;
  height: 390px;
}
#chartPie,
#chartPie3 {
  border-right: 1px solid #ebeef5;
}
</style>